import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { decideInitialLang } from './detect';
import enCommon from '@/locales/en/common.json';
import jaCommon from '@/locales/ja/common.json';

const initialLang = decideInitialLang();

void i18n.use(initReactI18next).init({
  resources: { en: { common: enCommon }, ja: { common: jaCommon } },
  lng: initialLang,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  parseMissingKeyHandler: (k) => k,
});

function syncHead() {
  const lang = (i18n.language || 'en').split('-')[0];
  document.documentElement.setAttribute('lang', lang);
  document.title = i18n.t('meta.title');
  const meta = document.querySelector('meta[name="description"]');
  if (meta) meta.setAttribute('content', i18n.t('meta.description'));
}

i18n.on('initialized', syncHead);
i18n.on('languageChanged', syncHead);
syncHead();

export default i18n;
